import React from 'react'
import injectStyles from 'react-jss'

const styles = {
  bar: {
    width: '100%',
    height: 3,
    position: 'relative',
    backgroundImage: 'linear-gradient(to right, #f8b833 0%, #fd4a1a 100%)',
  },
  innerBar: {
    height: 3,
    backgroundColor: '#f9fafa',
    float: 'right',
    width: '100%',
  },
}

const ProgressBar = ({ classes, progress }) => <div className={classes.bar}>
  <div
    className={classes.innerBar}
    style={{width: (100 - progress) + '%' }}
  />
</div>

export default injectStyles(styles)(ProgressBar)


// WEBPACK FOOTER //
// ./src/pages/Loading/ProgressBar.js